import { gql } from '@apollo/client';

import { Assignment } from '../../types';
import { AssignmentFragment } from '../fragments';

export interface StartAssignmentMutationVariables {
  courseId: string;
  assignmentId: string;
}

export interface StartAssignmentMutationResult {
  assignment: Assignment;
}

export const startAssignmentMutation = gql`
  mutation StartAssignmentMutation($courseId: String!, $assignmentId: String!) {
    assignment(courseId: $courseId, assignmentId: $assignmentId, input: {})
      @rest(type: "Assignment", path: "courses/{args.courseId}/assignments/{args.assignmentId}/start", method: "PUT") {
      ...Assignment
    }
  }
  ${AssignmentFragment}
`;
